import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { UserType } from "service";

export const useForUserType = () => {
  const { user_type } = useParams();
  const userType = useMemo(() => {
    if (
      user_type === UserType.Admin ||
      user_type === UserType.Manager ||
      user_type === UserType.Default
    )
      return user_type;

    return UserType.Default;
  }, [user_type]);

  return {
    userType,
    isIt: (type: UserType) => {
      return userType === type;
    },
  };
};
